<script setup lang="ts">
import type { SideLinkListProps } from '@/types/appTypes'

const props = withDefaults(defineProps<SideLinkListProps>(), {})
</script>

<template>
  <div
    class="c-sideLinkList"
  >
    <div
      v-for="(item, index) in props.items"
      v-bind:key="index"
      class="c-sideLinkItem"
    >
      <v-divider />
      <div class="c-sideLinkItem_panel">
        <template
          v-if="item.link.indexOf('http') === 0"
        >
          <a
            v-bind:href="item.link"
            class="c-sideLinkItem_image"
            target="_blank"
          >
            <CommonImage
              v-bind:src="item.pcImage.url"
              error-src="/images/noimage.svg"
              v-bind:alt="item.title"
              object-fit="cover"
              width="75"
              height="75"
            />
          </a>
          <div class="c-sideLinkItem_eventName">
            <a
              v-bind:href="item.link"
              target="_blank"
            >
              {{ item.title }}
            </a>
          </div>
        </template>
        <template
          v-else
        >
          <nuxt-link
            class="c-sideLinkItem_image"
            v-bind:to="item.link"
          >
            <CommonImage
              v-bind:src="item.image.url"
              error-src="/images/noimage.svg"
              v-bind:alt="item.title"
              object-fit="cover"
              width="75"
              height="75"
            />
          </nuxt-link>
          <div class="c-sideLinkItem_eventName">
            <nuxt-link
              v-bind:to="item.link"
            >
              {{ item.title }}
            </nuxt-link>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang = "scss" scoped>
.c-sideLinkList {
  position: relative;
}

.c-sideLinkItem {
  &_panel {
    display: flex;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  &_image {
    flex-shrink: 0;
    width: 75px;
    height: 75px;

    &[target="_blank"]::after {
      display: none;
    }

    &:hover {
      opacity: 0.7;
    }
  }

  &_eventName {
    flex-grow: 1;
    margin-left: 15px;
    font-family: var(--g_font_family_NotoSansCJKjp);
    font-size: 16px;
    font-weight: bold;
    word-break: break-all;

    a {
      color: #252525;
      font-weight: bold;
    }
  }
}
</style>
